import { render, staticRenderFns } from "./Plaka.vue?vue&type=template&id=5030255b"
import script from "./Plaka.vue?vue&type=script&lang=ts"
export * from "./Plaka.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports